import React, { useContext, useEffect, useRef, useState } from 'react';
import type { GetRef, InputRef, TableProps } from 'antd';
import { Button, Form, Input, Popconfirm, Table, Select, Row, Col, Divider, Space, Switch, message, InputNumber } from 'antd';
import styles from '../index.module.less'
import { modalCodeFn } from '@/pages/fmsConfig/receiptRulesManagement/components/codeRule';
import { httpDictServTenant } from '@/services/fmsServices'
import {
    receiptRulesPlanMainRulesPlanDetail, planCommonControllerFindFetchType,
    planCommonControllerFindRelevanceItem, receiptRulesPlanAddRulesBranchPlanDetail, receiptRulesPlanBranchDelete
} from '@/services/fmsConfig'
type FormInstance<T> = GetRef<typeof Form<T>>;

const EditableContext = React.createContext<FormInstance<any> | null>(null);
const Option = Select.Option


const EditableRow: React.FC<any> = ({ index, ...props }) => {
    const [form] = Form.useForm();
    return (
        <Form form={form} component={false}>
            <EditableContext.Provider value={form}>
                <tr {...props} />
            </EditableContext.Provider>
        </Form>
    );
};

interface EditableCellProps {
    title: React.ReactNode;
    editable: boolean;
    dataIndex: any;
    type: String;
    selectList: any;
    record: any;
    handleSave: (record: any) => void;
}

const EditableCell: React.FC<React.PropsWithChildren<EditableCellProps>> = ({
    title,
    editable,
    children,
    dataIndex,
    type,
    selectList,
    record,
    handleSave,
    ...restProps
}) => {
    const [editing, setEditing] = useState(false);
    const inputRef = useRef<InputRef>(null);
    const form = useContext(EditableContext)!;

    useEffect(() => {
        if (editing) {
            inputRef.current?.focus();
        }
    }, [editing]);

    const toggleEdit = () => {
        setEditing(!editing);
        form.setFieldsValue({ [dataIndex]: record[dataIndex] });
    };

    const save = async () => {
        try {
            const values = await form.validateFields();

            toggleEdit();
            handleSave({ ...record, ...values });
        } catch (errInfo: any) {
            console.log('Save failed:', errInfo);
            handleSave({ ...record, ...errInfo.values })
        }
    };
    let childNode = children;
    if (editable) {
        childNode = editing ? type === 'text' ? (
            <Form.Item
                style={{ margin: 0 }}
                name={dataIndex}
                rules={[{ required: true, message: `请输入${title}` }]}
            >
                <Input placeholder={`请输入${title}`} ref={inputRef} onPressEnter={save} onBlur={save} maxLength={50} />
            </Form.Item>
        ) : type === 'number' ? (
            <Form.Item
                style={{ margin: 0 }}
                name={dataIndex}
                rules={[{ required: true, message: `请输入${title}` }]}
            >
                <InputNumber
                    // disabled={record?.appoint}
                    min={0}
                    max={100}
                    placeholder={`请输入${title}`} 
                    onPressEnter={save} 
                    onBlur={save} 
                    // parser={value => value ? value.replace(/\D/g, '') : ''}
                    // formatter={value => value ? `${value}`.replace(/\D/g, '') : ''}
                    parser={value => {
                        if (!value) return '';
                        // Allow numbers and one decimal point
                        const parsed = value.toString().replace(/[^\d.]/g, '');
                        // Ensure only one decimal point and one decimal place
                        const parts = parsed.split('.');
                        if (parts.length > 2) return parts[0] + '.' + parts[1];
                        if (parts[1]?.length > 1) return parts[0] + '.' + parts[1].slice(0, 1);
                        return parsed;
                    }}
                    formatter={value => {
                        if (!value) return '';
                        // Allow numbers and one decimal point
                        const formatted = value.toString().replace(/[^\d.]/g, '');
                        // Ensure only one decimal point and one decimal place
                        const parts = formatted.split('.');
                        if (parts.length > 2) return parts[0] + '.' + parts[1];
                        if (parts[1]?.length > 1) return parts[0] + '.' + parts[1].slice(0, 1);
                        return formatted;
                    }}
                />
            </Form.Item>
        ) : (
            <Form.Item
                style={{ margin: 0 }}
                name={dataIndex}
                rules={[{ required: true, message: `请选择${title}` }]}
            >
                <Select 
                // disabled={record?.appoint}
                placeholder={`请选择${title}`} style={{ width: '100%', margin: '-5px 0' }} onChange={save}>
                    {selectList && selectList.map((item, index) => {
                        return (
                            <Option key={index} value={item.desc ? item.desc : item.name}>
                                {item.desc ? item.desc : item.name}
                            </Option>
                        );
                    })}
                </Select>
            </Form.Item>
        ) : (
            <div
                className={styles.editableCellValueWrap}
                style={{ paddingInlineEnd: 24 }}
                onClick={toggleEdit}
            >
                {children}
            </div>
        )
    }

    return <td {...restProps}>{childNode}</td>;
};

interface DataType {
    key: React.Key;
    name: string;
    age: string;
    address: string;
}

type ColumnTypes = Exclude<TableProps<DataType>['columns'], undefined>;

interface Props {
    rest?: any;
    onDataChange?: (hasChanges?: boolean) => void;
}

export default ({ rest, onDataChange }: Props) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [fetchRulesDisabled, setFetchRulesDisabled] = useState(false);
    const [rulesShow, setRulesShow] = useState(false);
    const [dataSource, setDataSource] = useState<any[]>([]);
    const [paymentTypeList, setPaymentTypeList] = useState([] as any);
    const [fetchTypeList, setFetchTypeList] = useState([] as any);
    const [relevanceItemList, setRelevanceItemList] = useState([] as any);
    const [count, setCount] = useState(2);
    const [isDisabled, setIsDisabled] = useState(false)
    useEffect(() => {
        getStatusOptions()
        getRulesPlanDetail()
    }, []);
    useEffect(() => {
        let bol = dataSource.some(
            item => item.receTermName == null || item.receTermName === '' ||
            item.paymentTypeName == null || item.paymentTypeName === '' ||
            item.sortVal == null ||
            item.ratio == null ||
            item.title == null || item.title === '' ||
            item.remarks == null || item.remarks === ''
        )
        setIsDisabled(bol)
      }, [dataSource])
    const getRulesPlanDetail = () => {
        form.setFieldsValue(rest)
        setFetchRulesDisabled(rest?.enabled ? true : false)
        receiptRulesPlanMainRulesPlanDetail({
            rulesPlanMainId: rest.planMainId,
            isFull: false,
            planId: rest.id
        }).then((res) => {
            res.rulesBranchPlanDetailVoList.forEach(m => {
                m.key = m.id
                // 删除多余的属性
                // delete m.id;
                // delete m.createdBy;
                // delete m.createdTime;
                // delete m.lastUpdatedTime;
                // delete m.modifiedBy;
                // delete m.tenantId;
                // delete m.rulesFullPlanId;
                // delete m.fetchGroupKey;
            });
            if (rest?.fetchType === 'redo_diff_amount') {
                setRulesShow(false)
            } else {
                setRulesShow(true) // 必填
            }
            setDataSource(res.rulesBranchPlanDetailVoList)
        })
    }
    const getStatusOptions = async () => {
        let paymentType = await httpDictServTenant({ parentKey: 'receiptType', enabled: 1 })
        let fetchType = await planCommonControllerFindFetchType()
        let relevanceItem = await planCommonControllerFindRelevanceItem()
        setPaymentTypeList(paymentType)
        setFetchTypeList(fetchType)
        setRelevanceItemList(relevanceItem)
    }
    const handleDelete = (record) => {
        if (record.id) {
            // receiptRulesPlanBranchDelete(record.id).then((res: any) => {
            //     message.success('删除成功')
                const newData = dataSource.filter((item) => item.key !== record.key);
                setDataSource(newData);
            // })
        } else {
            const newData = dataSource.filter((item) => item.key !== record.key);
            setDataSource(newData);
        }
    };

    const defaultColumns: any = [
        {
            title: '应收关联事项',
            dataIndex: 'receTermName',
            type: 'select',
            selectList: relevanceItemList,
            width: 160,
            editable: true,
        },
        {
            title: '收款类型',
            dataIndex: 'paymentTypeName',
            type: 'select',
            selectList: paymentTypeList,
            width: 140,
            editable: true,
        },
        {
            title: '顺序',
            dataIndex: 'sortVal',
            type: 'number',
            width: 100,
            editable: true,
        },
        {
            title: '比例（%）',
            dataIndex: 'ratio',
            width: 100,
            type: 'number',
            editable: true,
        },
        {
            title: '标题',
            dataIndex: 'title',
            width: 180,
            type: 'text',
            editable: true,
        },
        {
            title: '描述',
            dataIndex: 'remarks',
            width: 260,
            type: 'text',
            // ellipsis: true,
            editable: true,
        },
        {
            title: '操作',
            dataIndex: 'operation',
            width: 100,
            render: (_, record) =>
                dataSource.length >= 1 ? (
                    <Popconfirm title="是否删除?" onConfirm={() => handleDelete(record)}>
                       <Button color="danger" variant="link" disabled={record?.appoint}>删除</Button>
                    </Popconfirm>
                ) : null,
        },
    ];

    const handleAdd = () => {
        const newData: any = {
            key: count,
            receTermName: '',
            receTermType: '',
            paymentTypeName: '',
            paymentType: '',
            sortVal: '',
            ratio: '',
            title: '',
            remarks: '',
        };
        setDataSource([...dataSource, newData]);
        setCount(count + 1);
        onDataChange?.(true);
    };

    const handleCellSave = (row: DataType) => {
        const newData = [...dataSource];
        const index = newData.findIndex((item) => row.key === item.key);
        const item = newData[index];
        newData.splice(index, 1, {
            ...item,
            ...row,
        });
        setDataSource(newData);
        onDataChange?.(true);
    };

    const handleFormChange = () => {
        onDataChange?.(true);
    };

    const onFinish = (values: any) => {
        for (let m of dataSource) {
            const relevanceItem = relevanceItemList.find(n => m.receTermName === n.desc);
            const paymentType = paymentTypeList.find(n => m.paymentTypeName === n.name);
            if (relevanceItem) {
                m.receTermType = relevanceItem.code;
            }
            if (paymentType) {
                m.paymentType = paymentType.priKey;
            }
            m.planMainId = rest.planMainId
            m.rulesBranchPlanId = rest.id
        }
        let rulesBranch = {
            rulesBranchPlan: {
                planMainId: rest.planMainId,
                fetchType: values.fetchType,
                fetchRules: values.fetchRules,
                fetchRulesName: values.fetchRulesName,
                id: rest.id,
                enabled: values.enabled ? true : false
            },
            rulesBranchPlanList: dataSource
        }
        setLoading(true)
        receiptRulesPlanAddRulesBranchPlanDetail(rulesBranch).then((res) => {
            message.success(res.message || '操作成功')
            getRulesPlanDetail()
            setLoading(false)
            onDataChange?.(false);
        }).catch(err => {
            setLoading(false)
        })
    }
    const components = {
        body: {
            row: EditableRow,
            cell: EditableCell,
        },
    };

    const columns = defaultColumns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record: DataType) => ({
                record,
                editable: col.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                type: col.type,
                selectList: col.selectList,
                handleSave: handleCellSave,
            }),
        };
    });
    const openEditRule = () => {
        if (form.getFieldValue('fetchType') && form.getFieldValue('fetchType') != '') {
            const fetchRulesName = form.getFieldValue('fetchRulesName');
            const fetchRules = form.getFieldValue('fetchRules');
            const fetchTypeCode = form.getFieldValue('fetchType');
            let fetchRulesData = fetchRulesName ? { desc: fetchRulesName, code: fetchRules, fetchTypeCode,  } : { fetchTypeCode };
            modalCodeFn({
                fn: (data: any) => {
                    // 设置取数规则的值
                    form.setFieldsValue({
                        fetchRulesName: data.desc.join(' '),
                        fetchRules: data.code.join(' ')
                    })
                },
                ...fetchRulesData,
            });
        } else {
            message.error('请先选择取数类型')
        }
    }

    return (
        <div style={{ marginTop: 15 }}>
            <Form form={form} onFinish={onFinish} layout="inline" onValuesChange={handleFormChange}>
                <Form.Item
                    label="取数类型"
                    name="fetchType"
                    rules={[{ required: true, message: '请输入取数类型' }]}
                    style={{ width: 260 }}
                >
                    <Select style={{ width: '100%', margin: '-5px 0' }} disabled={fetchRulesDisabled}
                    onChange={(value) => {
                        // 根据选择的取数类型更新取数规则的必填状态
                        if (value === 'redo_diff_amount') {
                            setRulesShow(false)
                        } else {
                            setRulesShow(true) // 必填
                        }
                        // 取数类型改变清空取数规则
                        form.setFieldsValue({
                            fetchRulesName: '',
                            fetchRules: ''
                        })
                    }}
                    >
                        {fetchTypeList.map((item, index) => {
                            return (
                                <Option key={index} value={item.code}>
                                    {item.desc}
                                </Option>
                            );
                        })}
                    </Select>
                </Form.Item>
                <Form.Item style={{ width: 500 }}>
                    <Space direction="horizontal" style={{ display: 'flex', alignItems: 'flex-start' }}>
                        <Form.Item name="fetchRulesName" label="取数规则" rules={[{ required: rulesShow, message: '请编辑取数规则' }]}>
                            <Input style={{ width: 300 }} placeholder="取数规则" disabled={true} />
                        </Form.Item>
                        <Form.Item name="fetchRules" style={{ display: 'none' }}>
                            <Input />
                        </Form.Item>
                        <Button type="primary" onClick={openEditRule} disabled={fetchRulesDisabled}>编辑</Button>
                    </Space>
                </Form.Item>
                <Form.Item
                    label="是否主合同分期"
                    name="enabled"
                >
                    <Switch disabled={true} />
                </Form.Item>
                <Form.Item style={{ width: '100%', marginTop: 10 }}>
                    <Row gutter={24}>
                        <Col span={24}>
                            <div style={{ display: 'flex', justifyContent: 'end' }}>
                                <Button onClick={handleAdd} type="primary" style={{ marginBottom: 15 }}>
                                    新增
                                </Button>
                            </div>
                            <Table
                                size='small'
                                components={components}
                                rowClassName={() => styles.editableRow}
                                bordered
                                dataSource={dataSource}
                                columns={columns as ColumnTypes}
                                pagination={false}
                            />
                        </Col>
                    </Row>
                </Form.Item>
                <Form.Item style={{ width: '100%' }}>
                    <Row>
                        <Col span={24}>
                            <Divider />
                        </Col>
                        <Col span={24} style={{ textAlign: 'right' }}>
                            <Button type="primary" disabled={isDisabled} loading={loading} htmlType="submit" style={{ margin: '0 8px' }}>
                                保存
                            </Button>
                        </Col>
                    </Row>
                </Form.Item>
            </Form>
        </div>
    );
};